import script from "./ValuesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ValuesView.vue?vue&type=script&setup=true&lang=js"

import "./ValuesView.vue?vue&type=style&index=0&id=d7812b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7812b8e"]])

export default __exports__